<!-- Notifications toggle -->
<button
    mat-icon-button
    (click)="openPanel()"
    #notificationsOrigin>
    <ng-container *ngIf="unreadCount > 0">
        <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
            <span class="notification-badge">
                {{ unreadCount }}
            </span>
        </span>
    </ng-container>
    <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
    
</button>


<!-- Notifications panel -->
<ng-template #notificationsPanel>

    <div class="notifications-panel">

        <!-- Header -->
        <div class="notifications-header">
            <span>{{'notifications.title'|transloco}}</span>
            <button
                mat-icon-button
                [matTooltip]="'notifications.setAllRead' |transloco"
                [disabled]="unreadCount === 0"
                (click)="markAllAsRead()">
                <mat-icon [svgIcon]="'heroicons_solid:envelope-open'"
                [ngClass]="unreadCount > 0 ? 'icon-enabled' : 'icon-disabled'">
                </mat-icon>
            </button>
            <button
                mat-icon-button
                [matTooltip]="'notifications.removeAll' |transloco"
                [disabled]="notDeletedCount === 0"
                (click)="deleteAll()">
                <mat-icon [svgIcon]="'heroicons_solid:trash'"
                [ngClass]="notDeletedCount > 0 ? 'icon-enabled' : 'icon-disabled'">
                </mat-icon>
            </button>
        </div>

        <!-- Content -->
        <div class="notifications-content">

            <!-- Stato di caricamento -->
            <ng-container *ngIf="loading; else notificationsContent">
                <div class="loading-state">
                    <div class="spinner"></div> <!-- Spinner -->
                    <div>{{'notifications.loading' |transloco}}...</div>
                </div>
            </ng-container>

            <!-- Contenuto delle notifiche -->
            <ng-template #notificationsContent>
                <ng-container *ngFor="let notification of _notificationsService.allNotifications.flat()">
                    <div class="notification-item" [ngClass]="{ 'unread': !notification.Read }"
                    (click)="viewNotification(notification)">
                    
                        <!-- Titolo, descrizione e data -->
                        <div class="notification-content">
                            <div class="notification-title">{{ notification.Title }}</div>
                            <div 
                            class="notification-type"
                            [ngClass]="{
                                'type-info': notification.Type?.value === 'info',
                                'type-warning': notification.Type?.value === 'warn',
                                'type-link': notification.Type?.value === 'link',
                                'type-success': notification.Type?.value === 'success',
                                'type-alert': notification.Type?.value === 'alert',
                                'type-error': notification.Type?.value === 'error'
                            }">
                            ({{ notification.Type?.value.toUpperCase()}})
                        </div>
                            <div class="notification-text">
                                {{notification.Content }}
                            </div>
                            <div class="notification-date">{{ notification.SentDate | date: 'dd/MM/yyyy HH:mm' }}</div>
                        </div>

                        <!-- Azioni -->
                        <div class="notification-actions">
                            <button
                                mat-icon-button
                                (click)="toggleRead(notification); $event.stopPropagation()"
                                [matTooltip]="(notification.Read ? 'notifications.setNotRead' : 'notifications.setRead') | transloco">
                                <mat-icon 
                                    [svgIcon]="notification.Read ? 'heroicons_solid:envelope' : 'heroicons_solid:envelope-open'"
                                    [ngClass]="notification.Read ? 'icon-read' : 'icon-unread'">
                                ></mat-icon>
                                
                            </button>
                            <button
                                mat-icon-button
                                (click)="delete(notification); $event.stopPropagation()"
                                [matTooltip]="'notifications.remove' | transloco">
                                <mat-icon [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
                            </button>
                        </div>
                    </div>
                </ng-container>

                <!-- Nessuna notifica -->
                <ng-container *ngIf="!_notificationsService.allNotifications.flat() || !_notificationsService.allNotifications.length">
                    <div class="no-notifications">
                        <mat-icon class="no-notifications-icon" [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                        <div class="no-notifications-title">{{'notifications.noNotifications' |transloco}}</div>
                        <div class="no-notifications-desc">{{'notifications.noNotificationsDesc' |transloco}}</div>
                    </div>
                </ng-container>
            </ng-template>

        </div>

    </div>

</ng-template>
